import * as Common from '@/tenant/common';
import Moment from 'moment';

export class Counterpart extends Common.MasterBase{
  constructor(){
    super('Counterpart');
    this.binders.customer = new Common.ModelBinder(Counterpart);
    this.binders.payee = new Common.ModelBinder(Counterpart);
    this.binders.payer = new Common.ModelBinder(Counterpart);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public id: number= 0;
  public code: string = '';
  public name: string='';
  public counterpartType: CounterpartTypes = CounterpartTypes.Customer;
  public customerId: number = null;
  public customer: Counterpart = null;
  public postalCode: string = '';
  public address1: string = '';
  public address2: string = '';
  public address3: string = '';
  public telNo: string = '';
  public faxNo: string = '';
  public picSection: string = '';
  public pic: string = '';
  public honorificTitle: string = '';
  public mappingCodeBS: string = '';
  public mappingCodePL: string = '';

  // 請求・支払設定
  public payeeId: number = 0;
  public  payee: Counterpart = null;
  public payerId: number = 0;
  public  payer: Counterpart = null;
  public settlement: Common.SettlementTypes = Common.SettlementTypes.ByReceivable;
  public paymentTerm: string = '';
  public invoiceType: Common.InvoiceTypes = 0;
  public paymentDateType: PaymentDateTypes  = PaymentDateTypes.None;
  public paymentSite: number  = 0;
  public closingDate1: DateTypes  = DateTypes.None;
  public dueDate1: DateTypes  = DateTypes.None;
  public paymentMonth1: MonthTypes  = MonthTypes.None;
  public closingDate2: DateTypes  = DateTypes.None;
  public dueDate2: DateTypes  = DateTypes.None;
  public paymentMonth2: MonthTypes  = MonthTypes.None;
  
  // 銀行口座設定
  public customerBankAccountCode: string = null;
  public bankName: string = '';
  public bankBranchName: string = '';
  // public accountType: string = '';
  public accountCategory: Common.BankAccountCategoryTypes = Common.BankAccountCategoryTypes.Default;
  public accountCode: string = '';
  public accountName: string = '';
  // 振込連携設定（旧：全銀設定）
  public useFirmBanking: boolean = false;  
  public bankCode: string = null;
  public bankNameKana: string = null;
  public bankBranchCode: string = null;
  public bankBranchNameKana: string = null;  
  // 貿易書類設定
  public deliveryTerm: string = '';
  public deliveryLocation: string = '';
  public receiptPlace: string = '';
  public loadingPort: string = '';
  public dischargePort: string = '';
  public deliveryPlace: string = '';
  public countryOfDestination: string = '';
  public payFreight: string = '';
  public consignee: string = '';
  public deliveredTo: string = '';
  public transportation: TransportationTypes = TransportationTypes.None;
  public shipVia: string = '';
  public insurance: string = '';
  public shipTo: string = '';
  
  // その他設定
  public salesPerson: string = null;
  public commodityName: CommodityNameTypes = CommodityNameTypes.Name1;
  public priceCategory: number = null;
  public taxType: Common.TaxTypes = Common.TaxTypes.Without;
  public taxCode : string = null;
  public salesPricingRate: number = 100;
  public creditCategory: string = '';
  public currencyCode: string = null;
  public subAccountCode: string = '';
  public subAccountBS: any = null;
  public subAccountPL: any = null;
  public description: string = '';
  public remark: string = '';
  public forwarderInvoiceCode: string = '';
  public consignorCode: string = '';
  public invoiceNo: string = '';

  // 帳票設定
  public salesOrderReportTemplateId: number = null;
  public salesDeliveryReportTemplateId: number = null;
  public aloneInvoiceReportTemplateId: number = null;

  // 予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;
  
  // 集計項目
  public category1: number = null;
  public category2: number = null;
  public category3: number = null;
  public category4: number = null;
  public category5: number = null;
  public category6: number = null;

  public copy():any {
    const temp = super.copy() as Counterpart;
    temp.id = 0;
    temp.code = null;
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    temp.subAccountBS = null;
    temp.subAccountPL = null;
    return temp;
  }

  public getClosingDate(baseDate: Date, tenantSettings: Common.TenantSettings): Date{
    var closingDate = Moment(baseDate);
    var date = this.closingDate1;

    if(closingDate.get('date') > this.closingDate1){
      // 締日1を越えており、締日2が設定されている場合
      if(this.closingDate2 != DateTypes.None && closingDate.get('date') <= this.closingDate2){
        date = this.closingDate2;
      // 締日1を越えており、締日2が設定されていない場合
      // または締日2を越えている
      }else{
        closingDate.month(closingDate.get('month') + 1);
      }
    }

    if(date == DateTypes.LastDay){
      closingDate.month(closingDate.get('month') + 1);
      closingDate.date(0);
    }else{
      closingDate.date(date);
    }
    
    // 決算月末を締日に含む場合、算出された締日＞決算月末＞=baseDateの場合決算月末を採用する
    if(tenantSettings.yearEndClosingFlag == true){
      var yearEndDate = Moment(baseDate);
      yearEndDate.month(tenantSettings.startMonth - 1).date(0);
      var yearEndDate2 = yearEndDate.clone();
      yearEndDate2.year(yearEndDate2.get('year') + 1);
      if(closingDate > yearEndDate && yearEndDate >= Moment(baseDate)){
        closingDate = yearEndDate;
      }else if(closingDate > yearEndDate2 && yearEndDate2 >= Moment(baseDate)){
        closingDate = yearEndDate2;
      }
    }

    return new Date(closingDate.get('year'),closingDate.get('month'),closingDate.get('date'));
  }

  public getPaymentDate(bookDate: Date, tenantSettings: Common.TenantSettings): Date{
    var paymentDate = Moment(bookDate);
    
    // 支払日区分が月日指定の場合
    if(this.paymentDateType == PaymentDateTypes.Monthly){
      var dueMonth = this.paymentMonth1;
      var dueDate = this.dueDate1;

      if(bookDate.getDate() > this.closingDate1){
        // 締日1を越えており、締日2が設定されている場合
        if(this.closingDate2 != DateTypes.None && bookDate.getDate() <= this.closingDate2){
          dueMonth = this.paymentMonth2;
          dueDate = this.dueDate2;
        // 締日2も超えていて、決算月末の請求締処理が設定されていて、決済月末の場合、小さい値（締日1の支払日として扱う）
        }else if(tenantSettings.yearEndClosingFlag == true && bookDate.getMonth()+1 == tenantSettings.startMonth -1){
          dueMonth = this.paymentMonth1==MonthTypes.CurrentMonth?MonthTypes.Month1Later:this.paymentMonth1;
          dueDate = this.dueDate1;
        // 締日1を越えており、締日2が設定されていない場合
        // または締日2を越えている
        }else{
          dueMonth = this.paymentMonth1 + 1;
        }
      }

      if(dueDate == DateTypes.LastDay){
        paymentDate.month(paymentDate.get('month') + dueMonth);
        paymentDate.date(0);
      }else{
        paymentDate.month(paymentDate.get('month') + dueMonth - 1);
        paymentDate.date(dueDate);
      }
    // 支払日区分が日数指定の場合
    }else{
      paymentDate.date(bookDate.getDate() + this.paymentSite);
    }

    return new Date(paymentDate.get('year'),paymentDate.get('month'),paymentDate.get('date'));
  }
}

export enum CounterpartTypes {
  None = 0,
  Customer = 1,
  Supplier = 2,
  Receiver = 4,
  Warehouse = 8,
}

export enum PaymentDateTypes
{
  None = 0,
  Monthly = 1,
  Daily = 2,
}

export enum DateTypes
{
  None = 0,
  Day1 = 1,
  Day2 = 2,
  Day3 = 3,
  Day4 = 4,
  Day5 = 5,
  Day6 = 6,
  Day7 = 7,
  Day8 = 8,
  Day9 = 9,
  Day10 = 10,
  Day11 = 11,
  Day12 = 12,
  Day13 = 13,
  Day14 = 14,
  Day15 = 15,
  Day16 = 16,
  Day17 = 17,
  Day18 = 18,
  Day19 = 19,
  Day20 = 20,
  Day21 = 21,
  Day22 = 22,
  Day23 = 23,
  Day24 = 24,
  Day25 = 25,
  Day26 = 26,
  Day27 = 27,
  Day28 = 28,
  LastDay = 99,
}

export enum MonthTypes
{
  None = 0,
  CurrentMonth = 1,
  Month1Later = 2,
  Month2Later = 3,
  Month3Later = 4,
  Month4Later = 5,
  Month5Later = 6,
  Month6Later = 7,
}

export enum TransportationTypes
{
  None = 0,
  Air = 1,
  Sea = 2,
  Truck = 3,
}

export enum CommodityNameTypes
{
  None = 0,
  Name1 = 1,
  Name2 = 2,
  Name3 = 3,  
}

export class CounterpartQuery extends Common.LoadQuery {
  constructor(){
    super('CounterpartQuery',Counterpart);
    this.sort = 'code';
  }

  public code: string = '';
  public name: string = '';
  public counterpartType: CounterpartTypes = null;
  public category1: number = null;
  public category2: number = null;
  public category3: number = null;
  public category4: number = null;
  public category5: number = null;
  public category6: number = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class CounterpartMasterQuery extends Common.LoadQuery {
  constructor(){
    super('CounterpartMasterQuery',Counterpart);
  }
  public needsCustomer: boolean = false;
  public needsSupplier: boolean = false;
  public needsReceiver: boolean = false;
  public needsWarehouse: boolean = false;
  public customerId: number = null;
}

export class CounterpartImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "CounterpartImportQuery";
    this.sheetName = sheetName;
    this.hasLicenseCurrency = false;
    this.hasLicenseImport = false;
    this.hasLicenseExport = false;
  }
  public sheetName: string;
  public hasLicenseCurrency: boolean;
  public hasLicenseImport: boolean;
  public hasLicenseExport: boolean;
}

export class CounterpartExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "CounterpartExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.hasLicenseCurrency = false;
    this.hasLicenseImport = false;
    this.hasLicenseExport = false;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
  public hasLicenseCurrency: boolean;
  public hasLicenseImport: boolean;
  public hasLicenseExport: boolean;
}